export const DEFAULT_MAXIMUM_BUYER_GROUP_PER_ACCOUNT_SIZE = 10;
